export default {
  state: {
    imgUrl: '',
  },
  getters: {
    img: state => {
      return state
    },
  },
  mutations: {
    ADD_IMG(state, imgSrc) {
      state.imgUrl = imgSrc
    },
  },
  actions: {
    addImage({ commit }, eventUser) {
      commit('ADD_IMG', eventUser)
    },
  },
}
